import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import t1 from "../../assets/TeamSection/t1.jpeg";
import t2 from "../../assets/TeamSection/t2.jpeg";
import t3 from "../../assets/TeamSection/t3.jpeg";
import t4 from "../../assets/TeamSection/t4.jpeg";
import t5 from "../../assets/TeamSection/t5.jpeg";
import t6 from "../../assets/TeamSection/t6.jpeg";
import t7 from "../../assets/TeamSection/t7.jpeg";
import t8 from "../../assets/TeamSection/t8.jpeg";
import t9 from "../../assets/TeamSection/t9.jpeg";
import team from "../../assets/New/team.jpeg";

const images = {
  small: t3,
  stack1: t4,
  stack2: t6,
  large: t1,
};
const image2 = {
  small: t3,
  stack1: t9,
  stack2: t8,
  large: team,
};

export default function TeamGallerySection() {
  return (
    <Box
      sx={{
        py: { xs: 4, md: 4 },
        backgroundColor: "#fff",
        position: "relative",
      }}
    >
      {/* HEADER */}
      <Box sx={{ textAlign: "center", mb: 2, px: 2 }}>
        <Typography sx={{ fontSize: { xs: 28, md: 38 }, fontWeight: 600 }}>
          The People Behind Our{" "}
          <Box component="span" sx={{ color: "var(--color-gold)" }}>
            Success
          </Box>
        </Typography>

        <Typography
          sx={{
            maxWidth: 640,
            mx: "auto",
            mt: 1,
            color: "var(--color-text-muted)",
          }}
        >
          A passionate team of professionals dedicated to delivering excellence
          at every step.
        </Typography>
      </Box>

      {/* FULL WIDTH SWIPER */}
      <Swiper
        grabCursor
        modules={[Autoplay, FreeMode]}
        spaceBetween={0}
        freeMode={false}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1, // ✅ MOBILE: one by one
            spaceBetween: 0,
          },
          768: {
            slidesPerView: "auto", // ✅ TABLET & DESKTOP
            spaceBetween: 0,
          },
        }}
        // style={{ paddingLeft: 16, paddingRight: 16 }}
      >
        {/* REPEAT THIS SLIDE FOR MORE SETS */}
        <SwiperSlide style={{ width: "90vw" }}>
          <EditorialGrid images={images} />
        </SwiperSlide>

        <SwiperSlide style={{ width: "90vw" }}>
          <EditorialGrid images={image2} />
        </SwiperSlide>
      </Swiper>
      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}

function EditorialGrid({ images }) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "0.9fr 1fr 1.1fr",
        },
        // gap: 3,
        alignItems: "stretch",
        height: { xs: "auto", md: "100vh" },
      }}
    >
      {/* SMALL */}
      <ImageCard src={images.small} />

      {/* STACK */}
      <Box sx={{ display: "grid", gridTemplateRows: "1fr 1fr" }}>
        <ImageCard src={images.stack1} />
        <ImageCard src={images.stack2} />
      </Box>

      {/* LARGE */}
      <ImageCard src={images.large} />
    </Box>
  );
}

function ImageCard({ src }) {
  return (
    <Box
      sx={{
        position: "relative",
        // borderRadius: "22px",
        overflow: "hidden",
        minHeight: 360,
        height: "100%",
        // boxShadow: "0 25px 70px rgba(0,0,0,0.18)",
      }}
    >
      <Box
        component="img"
        src={src}
        alt=""
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* EDGE SHADOW */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(90deg, rgba(0,0,0,0.35), transparent 30%, transparent 70%, rgba(0,0,0,0.35))",
        }}
      />
    </Box>
  );
}
